// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"style_dashboardContainer__OShZa","dashboardContentContainer":"style_dashboardContentContainer__LmRl6","dashboardContent":"style_dashboardContent__7oUwH"};